import { useYear } from 'hooks/employee/useYear';
import { Loading } from 'jbc-front/components/presenters/ui/Loading';
import { Routes as Routes2024 } from 'years/2024/EmployeeRoutes';
// @ts-ignore
import { Route, Switch, Redirect } from 'react-router';
// @ts-ignore
import Layout from 'Layout';
// @ts-ignore
import * as _pages from 'employee_pages';
// @ts-ignore
import { withTracker } from 'components';

const pages = withTracker(_pages);

export const Routes = () => {
  const { loading, year } = useYear();

  if (loading) {
    return <Loading />;
  }

  if (!year) {
    return (
      <Layout showHeader={false} showFooter={false}>
        <Switch>
          <Route path="/employee_start" exact component={pages.EmployeeStart} />
          <Route
            path="/employee_(input|finished|expired)"
            exact
            component={() => <Redirect to="/employee_error?reason=session_expired" />}
          />
          <Route path="/employee_error" exact component={pages.ErrorPage} />
          <Route component={() => <div>not found</div>} />
        </Switch>
      </Layout>
    );
  }

  switch (year) {
    case 2024:
      return <Routes2024 />;
    default:
      return (
        <Layout showHeader={false} showFooter={false}>
          <Switch>
            <Route path="/employee_input" exact component={pages.EmployeeInput} />
            <Route path="/employee_finished" exact component={pages.Finished} />
            <Route path="/employee_expired" exact component={pages.Expired} />
            <Route path="/employee_error" exact component={pages.ErrorPage} />
            <Route component={() => <div>not found</div>} />
          </Switch>
        </Layout>
      );
  }
};
